/* eslint-disable */
import {ProductType} from "../constants/enums"
import {CurrencyCodes} from "../constants/countries"
import {includes} from "lodash"
const randomstring = require("randomstring")

export const apiRenamer = (API, findList, replaceList) => {
  let apiUrl = API

  for (let index = 0; index < replaceList.length; index++) {
    apiUrl = apiUrl.replace("[" + findList[index] + "]", replaceList[index])
  }

  return apiUrl
}

// TODO: What type of loader is it?
export const showLoader = () => {
  document.getElementsByClassName("xion-loader")[0].setAttribute("style", "display: block;")
}

export const hideLoader = () => {
  document.getElementsByClassName("xion-loader")[0] && document.getElementsByClassName("xion-loader")[0].setAttribute("style", "display: none;")
}

export const getPermissionObject = (companyList, permissions) => {
  const gst = []
  const tax = []
  const vault = []

  companyList.forEach((company) => {
    if (permissions !== null) {
      if (permissions[company.permID]) {
        const companyPerm = permissions[company.permID]
        if (companyPerm[ProductType.GSTAUDIT]) {
          gst.push({
            company: company.name,
            companyId: company.companyID,
            role: companyPerm[ProductType.GSTAUDIT],
            isChecked: true,
          })
        } else {
          gst.push({
            company: company.name,
            companyId: company.companyID,
            role: "",
            isChecked: false,
          })
        }
        if (companyPerm[ProductType.TAXASSIST]) {
          tax.push({
            company: company.name,
            companyId: company.companyID,
            role: companyPerm[ProductType.TAXASSIST],
            isChecked: true,
          });
        } else {
          tax.push({
            company: company.name,
            companyId: company.companyID,
            role: "",
            isChecked: false,
          });
        }
        if (companyPerm[ProductType.VAULT]) {
          vault.push({
            company: company.name,
            companyId: company.companyID,
            role: companyPerm[ProductType.VAULT],
            isChecked: true,
          });
        } else {
          vault.push({
            company: company.name,
            companyId: company.companyID,
            role: "",
            isChecked: false,
          });
        }
      } else {
        gst.push({
          company: company.name,
          companyId: company.companyID,
          role: "",
          isChecked: false,
        });
        tax.push({
          company: company.name,
          companyId: company.companyID,
          role: "",
          isChecked: false,
        });
        vault.push({
          company: company.name,
          companyId: company.companyID,
          role: "",
          isChecked: false,
        });
      }
    } else {
      gst.push({
        company: company.name,
        companyId: company.companyID,
        role: "",
        isChecked: false,
      });
      tax.push({
        company: company.name,
        companyId: company.companyID,
        role: "",
        isChecked: false,
      });
      vault.push({
        company: company.name,
        companyId: company.companyID,
        role: "",
        isChecked: false,
      });
    }
  });
  return { GSTAudit: gst, TaxAssist: tax, Vault: vault };
};

export const getPermissionJson = (permissions, email, text) => {
  let gst = permissions[ProductType.GSTAUDIT];
  let tax = permissions[ProductType.TAXASSIST];
  let vault = permissions[ProductType.VAULT];
  let objects = {};
  for (let index = 0; index < gst.length; index++) {
    let gstObj = gst[index];
    let taxObj = tax[index];
    let vaultObj = vault[index];
    let companyValue = "";
    let gstCompanyRole,
        taxCompanyRole,
        vaultCompanyRole = "";
    if (gstObj.isChecked) {
      companyValue = gstObj.companyId;
      gstCompanyRole = gstObj.role;
    }
    if (taxObj.isChecked) {
      companyValue = taxObj.companyId;
      taxCompanyRole = taxObj.role;
    }
    if (vaultObj.isChecked) {
      companyValue = vaultObj.companyId;
      vaultCompanyRole = vaultObj.role;
    }
    if (companyValue !== "") {
      let newObj = {};
      if (gstCompanyRole && gstCompanyRole !== "") {
        newObj[ProductType.GSTAUDIT] = gstCompanyRole;
      }
      if (taxCompanyRole && taxCompanyRole !== "") {
        newObj[ProductType.TAXASSIST] = taxCompanyRole;
      }
      if (vaultCompanyRole && vaultCompanyRole !== "") {
        newObj[ProductType.VAULT] = vaultCompanyRole;
      }
      objects[companyValue] = newObj;
    }
  }
  return objects
}

export const ObjectsAreEqual = (o1, o2) => o1 && o2 && typeof o1 === "object" &&
    Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length &&
        Object.keys(o1).every((p) => ObjectsAreEqual(o1[p], o2[p]))
        : o1 === o2

export const ArraysAreEqual = (a1, a2) => a1.length === a2.length &&
    a1.every((o, idx) => ObjectsAreEqual(o, a2[idx]))


export const CloneOf = (item) => {
  if (item) {
    if (Array.isArray(item)) {
      const newArr = []
      item.forEach((x) => {
        switch (typeof x) {
          case "bigint":
          case "boolean":
          case "number":
          case "string":
            newArr.push(x);
            break;
          case "object":
            newArr.push(CloneOf(x));
            break;
          default:
            newArr.push(null);
            break;
        }
      })
      return newArr
    } else if (typeof item === "object") {
      const newObj = {},
          keys = Object.keys(item);
      keys.forEach((key) => {
        const el = item[key];
        if (Array.isArray(el)) newObj[key] = CloneOf(el);
        else newObj[key] = el;
      });
      return { ...newObj };
    }
  }
  return null;
}

export const replacer = (key, value) => {
  // Filtering out properties
  if (typeof value === "number" || typeof value === "boolean") {
    return value.toString();
  }
  return value;
}

export const replacerSpecialCharacters = (key, value) => {
  // Filtering out properties
  if (key === "Currency") {
    const currencyExist = includes(CurrencyCodes, value ? value.toUpperCase() : "");
    return currencyExist ? value.toUpperCase() : "";
    // return value ? value.toUpperCase() : "";
  } else if (typeof value === "string" && key !== "Invoice Date") {
    return value ? value.replace(/[\/\\|'"“:{}]/g, "").trim() : "";
  }
  return value;
}

export const ValidateNumber = (event) => {
  if (isNaN(event.target.value + String.fromCharCode(event.keyCode))) {
    return false;
  }
}

export const formatDateInDDMMMYYYY = (dateString) => {
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const date = new Date(dateString),
      day = date.getDate(),
      monthIndex = date.getMonth(),
      year = date.getFullYear();

  return day + " " + monthNames[monthIndex] + " " + year;
}

export const formatDateInMMDDYYYY = (dateString) => {
  const date = new Date(dateString),
      day = date.getDate(),
      monthIndex = date.getMonth(),
      year = date.getFullYear();
  return monthIndex + 1 + "/" + day + "/" + year;
}

export const formatAdjustmentDate = (dateString) => {
  const date = new Date(dateString),
      day = date.getDate(),
      monthIndex = date.getMonth(),
      year = date.getFullYear();
  const month = monthIndex + 1 < 10 ? `0${monthIndex + 1}` : monthIndex + 1;
  const monthDate = day < 10 ? `0${day}` : day;
  return month + "-" + monthDate + "-" + year;
}

export const formatMonth = (dateString) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const date = new Date(dateString),
      day = date.getDate(),
      monthIndex = date.getMonth(),
      year = date.getFullYear();

  return `${monthNames[monthIndex]}${year}`;
};

export const getGUIds = (length) => {
  let ids = [];
  for (let index = 0; index < length; index++) {
    ids.push(randomstring.generate());
  }
  return ids;
};

export const getFileNameFromUrl = (url) => {
  if (url) {
    var m = url.toString().match(/.*\/(.+?)\./);
    if (m && m.length > 1) {
      return m[1];
    }
  }
  return "";
};

export const kFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + "k" : (Math.sign(num) * Math.abs(num)).toFixed(2);
};

export const getLastDayOfMonth = (month) => {
  const monthLastDays = ["1-31", "2-28", "3-31", "4-30", "5-31", "6-30", "7-31", "8-31", "9-30", "10-31", "11-30", "12-31"];
  return monthLastDays[month - 1];
};


export const getIRASMaintenanceStatus = () => {
  const currentDate = new Date()
  console.log("date - " + currentDate);
  const daylist = ["Sunday", "Monday", "Tuesday", "Wednesday ", "Thursday", "Friday", "Saturday"]
  const currentDay = daylist[currentDate.getDay()];
  const currentHours = currentDate.getHours();
  console.log("day - " + currentDay + ", Hours - " + currentHours);
  //Sandbox Maintenance Timing
  if ((currentHours >= 13 && currentHours <= 15) || (currentHours >= 20 && currentHours <= 22)) {
    return true;
  }
  else if ((currentDay === "Sunday" && currentHours >= 20) || (currentDay === "Monday" && currentHours <= 3)) {
    return true;
  }
  else if (currentDay === "Wednesday" && currentHours >= 15 && currentHours < 24) {
    return true
  }
  else {
    return false;
  }

  //Production Maintenance Timing
  // if (currentDay === "Wednesday" && currentHours >= 2 && currentHours <= 6) {
  //   return true;
  // }
  // else if (currentDay === "Sunday" && currentHours >= 2 && currentHours <= 8) {
  //   return true;
  // }
  // else
  //   return false;

}
